import React, { useEffect, useState } from "react";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import backicon from './../../../../../../Assets/icons/backIcon.svg';
//import "./index.scss";
import { useLocation, useNavigate } from "react-router-dom";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import axiosInstance from "../../../../../services/api/API";
import { toastError, toastSuccess } from "../../../../../customComponents/customToast/Toast";
import { ToastContainer } from "react-toastify";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import Swal from "sweetalert2";


const EditDepartment = () => {
  const [formData, setFormData] = useState({});
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [ department, setDEpartment ] = useState([])
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const Token = localStorage.getItem("authToken");
  const location = useLocation();
  const { data } = location.state || {};
  const [ userTypedd, setUserTypedd ] = useState([])
  const userType = localStorage.getItem("UserType")
  const businessPartnerId = localStorage.getItem("business_partner_id")

  useEffect(() => {
    userTypedropdown()
  },[])
  
  const userTypedropdown = async () => {
    try{
      const response = await axiosInstance.get("/bp-onboard/bplist",{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      })
  
      const data = response.data.data.data
      const userTypeOptions = data.map(user => ({
        value: user.onboard_id,
        label:user.bp_name,
      }))
      setUserTypedd(userTypeOptions)
    }catch(error) {
      console.log(error)
    }
  }

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;
  
    // Validate form fields
    DepartmentInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      }
    });
  
    // If validation fails, set errors and return
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
  
    setLoading(true);
    console.log("formData", formData);
  
    // Confirmation before submission
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to update this department?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No, cancel",
    });
  
    // If the user cancels, reset loading state and exit
    if (!result.isConfirmed) {
      setLoading(false);
      return;
    }
  
    try {
      const payload = {
        department_name: formData.department_name,
        department_desc: formData.department_desc,
        status: formData.status === "Active" ? 1 : 0,
      };
  
      // Handle business partner ID based on user type
      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }
  
      // API request to update the department
      const response = await axiosInstance.patch(`/department/update/${data.department_id}`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
  
      // Success handling
      if (response.status === 200) {
        console.log("Department updated successfully:", response.data);
  
        // Success alert
        Swal.fire({
          title: "Success",
          text: "Department updated successfully!",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          navigate('/admin/manage-dealer/department'); // Navigate after user clicks OK
        });
      }
    } catch (error) {
      console.error('Error updating department:', error);
      
      // Error handling with SweetAlert
      const errorMessage = error.response?.data?.message || "An error occurred while processing your request.";
      
      Swal.fire({
        title: "Something went wrong",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false); // Stop loading state
    }
  };
  

  const fetchDepartmentEdit = async () => {
    try{
      const response = await axiosInstance.get(`/department/edit/${data.department_id}`,{
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
        },
    })
    const formatData = response.data.data;
    const transformedData = {
      department_name: formatData.department_name,
      department_desc: formatData.department_desc,
      status: formatData.status === 1 ? "Active" : "Inactive",
      business_partner_id:formatData.business_partner_id,
    }
    setFormData(transformedData)
    setDEpartment(formatData)
    console.log(formData, "depatartment DATA")
  
  }catch(error){
      console.log(error)
    }
  
  }
  
  useEffect(() => {
    fetchDepartmentEdit()
  },[])

  const DepartmentInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
            
          },
        ]
      : []),
    {
      name: "department_name",
      label: "Department Name",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true,
        pattern: /^[A-Za-z0-9-\s]*$/,
        message: "Special symbols are not allowed",
       },
    },
    {
      name: "department_desc",
      label: "Description",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
        { label: "Active", value: "Active" },
        { label: "Inactive", value: "Inactive" },
      ],
      validation: {
        required: true,
        message: "Status is required",
      },
      gridClass: "col-lg-4",
    },
    // {
    //   name: "actions",
    //   label: "Actions",
    //   type: "multiselectdropdown",
    //   required: true,
    //   options: [
    //     { label: "Edit", value: "Edit" },
    //     { label: "Delete", value: "Delete" },
    //   ],
    //   gridClass: "col-lg-4",
    // },
  ];

  return (
    <>
    <ToastContainer />
      <div className="backbutton mt-2 mb-2" onClick={() => navigate(-1)}>
        <img src={backicon} alt="back" />
        <span className="backbtntitle">Edit Department</span>
      </div>
      <div className="form-container">
        <span className="cust-det-title mt-2 mb-2">
          Please Enter Department Details
        </span>
        <DynamicForm
          formConfig={DepartmentInputs}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />
      </div>
      <div className="btncontainer mt-3">
        <button
          onClick={() => {
            if (!isFormSubmitted) {
              handleFormSubmit(formData); // Call handleFormSubmit if isFormSubmitted is false
            }
          }}
          className="submit-btn"
        >
          Submit
        </button>
      </div>
    </>
  );
};

export default EditDepartment;
